import { Testimonial } from "../models/testimonials.types";

export const testimonials: Testimonial[] = [
    // Landing Page Testimonials
    {
      id: "testimonial-1",
      quote: "I have relied on Industry Intelligence for more than 10 years. Everyday, every one of my marketing and sales team receives invaluable market intelligence tailored to our business, allowing us to make sound business decisions to meet our goals and expand our company. Industry Intelligence has helped us keep a pulse on our customers, our competitors and stay competitive in today's fast-paced market.",
      genericTitle: "VP of Global Marketing",
      industry: "Leading Packaging Corporation",
      region: "North America",
      tags: {
        landingPage: true,
        products: ["Competitive Edge"],
        industries: ["Packaging"],
        functions: ["Marketing", "Sales"]
      }
    },
    {
      id: "testimonial-2",
      quote: "As the leader of a global consumer goods packaging development team, I leveraged the information from Industry Intelligence on a daily basis. It provided insights into competitive initiatives, package innovation and supplier developments. This has enabled me to be ahead of potentially critical issues that threatened business as well as allow me to develop long term strategic plans and bring innovation and margin enhancements to market.",
      genericTitle: "Senior R&D Manager",
      industry: "Global Consumer Goods Manufacturer",
      region: "Global",
      tags: {
        landingPage: true,
        products: ["Supplier IQ", "Customer Insight"],
        industries: ["Food & Beverage", "Packaging"],
        functions: ["Research", "Strategy"]
      }
    },
    {
      id: "testimonial-3",
      quote: "As SVP of Sales for a global, Fortune 500 packaging corporation, I need to be at the forefront of industry trends and latest developments, especially relative to my customers and competitors. Industry Intelligence provides me with a succinct daily news summary, tailored to my role, that allows me to share action items with my team, provide timely insights to my customers, and stay ahead of the competition.",
      genericTitle: "SVP of Sales",
      industry: "Fortune 500 Packaging Corporation",
      region: "Global",
      tags: {
        landingPage: true,
        products: ["Daily Market Report", "Competitive Edge"],
        industries: ["Packaging"],
        functions: ["Sales", "Strategy"]
      }
    },
    
    // Product Page Testimonials - Supplier IQ
    {
      id: "testimonial-4",
      quote: "The real value of Industry Intelligence is having the expertise to understand what is relevant and what is not, then bringing it all together in one spot.",
      genericTitle: "VP of Marketing",
      industry: "Leading Developer of Sustainable Chemicals",
      region: "North America",
      tags: {
        products: ["Supplier IQ"],
        industries: ["Chemicals"],
        functions: ["Procurement", "Research"]
      }
    },
    {
      id: "testimonial-5",
      quote: "Industry Intelligence helps us understand where we sit in the industry and helps us answer perhaps the most important question: Are we on the right path?",
      genericTitle: "Director of Packaging Technology and Engineering",
      industry: "Consumer Goods Manufacturer",
      region: "Global",
      tags: {
        products: ["Supplier IQ"],
        industries: ["Packaging", "Retail"],
        functions: ["Research", "Strategy"]
      }
    },
    {
      id: "testimonial-6",
      quote: "I look at the information that Industry Intelligence provides daily. With Industry Intelligence, we get customized information targeted towards the segments we sell into, key customer announcements, and information on potential demand/supply and cost drivers for our business. I haven't seen another service that has the degree of focus and customization available for the pulp and paper industry.",
      genericTitle: "Senior Director",
      industry: "Pulp and Paper Manufacturer",
      region: "North America",
      tags: {
        products: ["Supplier IQ", "Daily Market Report"],
        industries: ["Pulp & Paper"],
        functions: ["Sales", "Strategy"]
      }
    },
    
    // Product Page Testimonials - Customer Insight
    {
      id: "testimonial-7",
      quote: "Industry Intelligence is a premier source for health and beauty across the globe. In the fast-paced world of beauty, staying on top of the competitive environment, supply chain issues, and market disruptions is critical. Industry Intelligence provides us with comprehensive insights—from raw material suppliers and converters to equipment manufacturers and brands—along with timely market information and trends. I've relied on Industry Intelligence for many years, and it has been an invaluable resource in helping us innovate and stay ahead of the curve.",
      genericTitle: "Senior Leader",
      industry: "Global Beauty and Cosmetics Company",
      region: "Global",
      tags: {
        products: ["Customer Insight"],
        industries: ["Personal Care", "Retail"],
        functions: ["Research", "Strategy"]
      }
    },
    {
      id: "testimonial-8",
      quote: "The ability to lean on Industry Intelligence for insights on our short-term and fast paced revolving projects is incredibly valuable. With limited time and resources, Industry Intelligence enabled us to quickly identify trends, gain insights and develop a clear perspective on our strategic Sprint Projects. Integration with MS Teams and our project-based channels eased the flow of information and gave us a venue to collaborate effectively.",
      genericTitle: "Marketing and Technology Manager",
      industry: "Major Paper Products Manufacturer",
      region: "North America",
      tags: {
        products: ["Customer Insight"],
        industries: ["Pulp & Paper", "Building Products"],
        functions: ["Marketing", "Research"]
      }
    },
    {
      id: "testimonial-9",
      quote: "Industry Intelligence's service has been a great way to keep our teams updated! Their market insights and comprehensive data help us make informed decisions, stay ahead of trends, and navigate industry shifts with ease. Highly recommend their service for anyone looking to stay competitive and informed!",
      genericTitle: "Senior Executive",
      industry: "Specialty Packaging Solutions Provider",
      region: "Global",
      tags: {
        products: ["Customer Insight"],
        industries: ["Packaging"],
        functions: ["Strategy", "Sales"]
      }
    },
    
    // Product Page Testimonials - Competitive Edge
    {
      id: "testimonial-10",
      quote: "If it's not on the Industry Intelligence news feed, then it didn't happen. Because if it's not there, it doesn't get brought up in meetings, sales reps and senior management aren't talking about it – nobody's talking about it. It's almost like it didn't happen. But if it's there, it really happened.",
      genericTitle: "Director of Marketing",
      industry: "Specialty Paper Solutions Provider",
      region: "North America",
      tags: {
        products: ["Competitive Edge"],
        industries: ["Pulp & Paper", "Printing"],
        functions: ["Marketing", "Sales"]
      }
    },
    
    // Product Page Testimonials - Legislation Monitor
    {
      id: "testimonial-11",
      quote: "In our industry, manually tracking every new piece of federal and especially state legislation is simply impossible—and the cost of missing critical updates can be enormous. With this service, we receive tailored, industry-specific intelligence that reviews every impactful piece of legislation regularly. It's been a game changer for our team, enabling us to stay ahead of the curve, mitigate risks, and capitalize on market opportunities.",
      genericTitle: "Regulatory Affairs Manager",
      industry: "Leading Food Manufacturing Company",
      region: "North America",
      tags: {
        products: ["Legislation Monitor"],
        industries: ["Food & Beverage"],
        functions: ["Compliance", "Strategy"]
      }
    },
    
    // Additional testimonials would be added for each product, industry and function
    // This is a starting template that can be expanded with more testimonials
  ];
  
  /**
   * Helper functions to filter testimonials for different pages
   */
  
  export const getLandingPageTestimonials = (): Testimonial[] => {
    return testimonials.filter(t => t.tags.landingPage);
  };
  
  export const getProductTestimonials = (product: string): Testimonial[] => {
    return testimonials.filter(t => t.tags.products?.includes(product));
  };
  
  export const getIndustryTestimonials = (industry: string): Testimonial[] => {
    return testimonials.filter(t => t.tags.industries?.includes(industry));
  };
  
  export const getFunctionTestimonials = (functionName: string): Testimonial[] => {
    return testimonials.filter(t => t.tags.functions?.includes(functionName));
  };
  
  /**
   * Example usage:
   * 
   * // Get testimonials for the landing page
   * const landingPageQuotes = getLandingPageTestimonials();
   * 
   * // Get testimonials for the Supplier IQ product page
   * const supplierIQQuotes = getProductTestimonials('Supplier IQ');
   * 
   * // Get testimonials for the Packaging industry page
   * const packagingQuotes = getIndustryTestimonials('Packaging');
   * 
   * // Get testimonials for the Sales function page
   * const salesQuotes = getFunctionTestimonials('Sales');
   */